export const checkAutoLoginUser = (url) => {
  let user
  let queryParams = new URLSearchParams(url)
  if (queryParams.has('usuario')) {
    try {
      let userParam = queryParams.get('usuario')
      user = JSON.parse(Buffer.from(userParam, 'base64').toString())
    } catch (error) {
      console.log('Error parsing user info', error)
    }
  }
  return user
}

export default checkAutoLoginUser
